export default __webpack_public_path__ + "static/media/armorripper2.1b2e6a94.png";